import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
export const Parent = styled(FlexColumnDiv) `
    line-height: normal;
    gap: 16px;
    & ul {
        margin-top: 8px;
        margin-bottom: 0px;
        padding-left: 24px;

        & li {
            padding-left: 4px;
        }
    }
`;
export const Title = styled.div `
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
    text-decoration: underline;
`;
